import {
  createFileRoute,
  Outlet,
  redirect,
  useLocation,
  useNavigate,
} from "@tanstack/react-router";
import { msalInstance } from "@/auth/msal.ts";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar.tsx";
import { AppSidebar } from "@/components/layout/sidebar/AppSidebar.tsx";
import { Toaster } from "sonner";
import { InsetHeader } from "@/components/layout/InsetHeader.tsx";
import { DialogRenderer } from "@/components/DialogRenderer.tsx";
import { useAuthStatus } from "@/lib/userStore.ts";
import { Loading } from "@/components/Loading.tsx";
import { useEffect } from "react";

export const Route = createFileRoute("/_auth")({
  beforeLoad: ({ location }) => {
    const isBrowser = typeof window !== "undefined";
    if (!isBrowser) return;

    const acc =
      msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

    if (!acc) {
      throw redirect({
        to: "/login",
        search: { redirect: location.href },
        replace: true,
      });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  const status = useAuthStatus();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (status === "unauthenticated") {
      void navigate({
        to: "/login",
        search: { redirect: location.href },
        replace: true,
      });
    }
  }, [status, navigate, location.href]);

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <InsetHeader />
        <main className="h-full w-full">
          {status === "authenticated" ? (
            <>
              <Outlet />
              <DialogRenderer />
            </>
          ) : (
            <Loading />
          )}
        </main>
        <Toaster />
      </SidebarInset>
    </SidebarProvider>
  );
}
